module.exports = {"Type":"AdaptiveCard","Disabled":false,"Output":true,"Fields":[{"label":"Card Definition","type":"multiline","name":"text","serializeTo":"q"},{"label":"Name of the variable","name":"name","serializeTo":"node"},{"label":"Update last activity","type":"yesno","defaultValue":"No","name":"updateLastActivity","advanced":true}],"Header":{"Color":"white","BackgroundColor":"#EE1010","Text":"CARD(EDIT)"}}


//////////////////
// WEBPACK FOOTER
// ./src/designer/widgets/AdaptiveCard.json
// module id = 678
// module chunks = 0